/**
 * User Notifications System — уведомления для клиентов/дизайнеров.
 *
 * Поллинг каждые 30 секунд. При открытии окна — все уведомления помечаются
 * просмотренными (markAllAsViewed).
 */

import { apiRequest } from '../../api.js';

function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
}

async function loadNotificationsCount() {
    try {
        const response = await apiRequest('/user/notifications', { method: 'GET' });
        if (response && response.success) {
            updateNotificationCount(response.count);
            updateNotificationsList(response.notifications);
        }
    } catch (e) {
        console.error('Error loading user notifications:', e);
    }
}

function updateNotificationCount(count) {
    const mailLink = document.querySelector('.header_link--mail');
    if (!mailLink) return;

    let counter = mailLink.querySelector('.header_icon_link_notice');

    if (count > 0) {
        if (!counter) {
            counter = document.createElement('span');
            counter.className = 'header_icon_link_notice';
            mailLink.appendChild(counter);
        }
        counter.textContent = count;
        counter.style.display = '';
    } else if (counter) {
        counter.style.display = 'none';
    }
}

function updateNotificationsList(notifications) {
    const list = document.getElementById('userNotificationsList');
    if (!list) return;

    if (!notifications || notifications.length === 0) {
        list.innerHTML = '<div class="adm_noti_window_item"><span class="adm_noti_window_item_caption">No new messages</span></div>';
        return;
    }

    list.innerHTML = notifications.map(n => {
        const itemClass = n.is_read ? 'adm_noti_window_item' : 'adm_noti_window_item unread';
        const link = (n.link && n.link !== '#')
            ? `<a class="adm_noti_window_item_link" href="${escapeHtml(n.link)}" data-notification-id="${escapeHtml(String(n.id))}">View more</a>`
            : '';
        return `
            <div class="${itemClass}" data-notification-id="${escapeHtml(String(n.id))}">
                <span class="adm_noti_window_item_caption">${escapeHtml(n.message)}</span>
                ${link}
                <span class="adm_noti_window_item_time">${escapeHtml(n.created_at)}</span>
            </div>
        `;
    }).join('');
}

function toggleNotificationWindow() {
    const notifWindow = document.getElementById('userNotificationWindow');
    const icon = document.querySelector('.header_link--mail');
    if (!notifWindow || !icon) return;

    const isVisible = notifWindow.offsetWidth > 0 && notifWindow.offsetHeight > 0;

    if (isVisible) {
        notifWindow.style.display = 'none';
        return;
    }

    // Позиционируем relative к иконке, проверяем не вылезает ли за viewport
    const iconRect = icon.getBoundingClientRect();
    const docWidth = document.documentElement.clientWidth;
    const windowWidth = 320;
    let rightPosition = docWidth - iconRect.right;
    if (rightPosition + windowWidth > docWidth) {
        rightPosition = docWidth - windowWidth - 20;
    }

    notifWindow.style.right = rightPosition + 'px';
    notifWindow.style.top = '60px';
    notifWindow.style.display = 'block';

    loadNotificationsCount();
    markAllAsViewed();
}

async function markAsRead(notificationId) {
    try {
        const response = await apiRequest(`/user/notifications/${notificationId}/read`, { method: 'POST' });
        if (response && response.success) {
            loadNotificationsCount();
        }
    } catch (e) {
        console.error('Error marking notification as read:', e);
    }
}

async function markAllAsViewed() {
    try {
        const response = await apiRequest('/user/notifications/view-all', { method: 'POST' });
        if (response && response.success) {
            setTimeout(loadNotificationsCount, 1000);
        }
    } catch (e) {
        console.error('Error marking all notifications as viewed:', e);
    }
}

function initUserNotifications() {
    if (!document.querySelector('.header_link--mail')) return;

    loadNotificationsCount();
    setInterval(loadNotificationsCount, 30000);

    // Клик по иконке почты — открыть окно
    document.addEventListener('click', e => {
        const mailLink = e.target.closest('.header_link--mail');
        if (mailLink) {
            e.preventDefault();
            toggleNotificationWindow();
            return;
        }

        // Клик вне окна — закрыть
        if (!e.target.closest('#userNotificationWindow, .header_link--mail')) {
            const notifWindow = document.getElementById('userNotificationWindow');
            if (notifWindow) notifWindow.style.display = 'none';
        }

        // Клик по "View more" в уведомлении — mark as read
        const readLink = e.target.closest('.adm_noti_window_item_link[data-notification-id]');
        if (readLink) {
            markAsRead(readLink.dataset.notificationId);
            // Не preventDefault — пусть переход по href сработает
        }
    });
}

// Публичный API
window.markAsRead = markAsRead;
window.loadUserNotificationsCount = loadNotificationsCount;

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUserNotifications);
} else {
    initUserNotifications();
}
